import './functions/svg4everybody';

import ready from './functions/ready';
import { lazy } from './scripts/lazy';
import { initDomSlider } from './modules/domSlider';
import { navBlog } from './scripts/navBlog';
import addPhoto from './scripts/addPhoto.js';
import smoothScroll from './scripts/smoothScroll';
import { sliderBlog } from './scripts/slider-blog.js';
import search from './scripts/search.js';
import { pagingPage } from './scripts/pagingPage.js';
import { newsletterBlog } from './scripts/newsletterBlog.js';
import { surveyBlog } from './scripts/surveyBlog.js';
import { cookieConsent } from './scripts/cookieConsent';
import helloBars from './scripts/helloBars';
import scrollBehavior from './functions/scrollBehavior';
import { setTables } from './functions/setTables';
import { exitModal } from './scripts/exitModal';
import { eventDataLayerActions } from './scripts/eventDataLayerActions';
import { youtubeVideo } from './scripts/youtubeVideo';
import { ajaxForm } from './scripts/ajaxForm';
import tooltip from './scripts/tooltip.js';

ready(() => {
  lazy();
  initDomSlider();
  navBlog();
  addPhoto();
  smoothScroll();
  sliderBlog();
  search();
  pagingPage();
  newsletterBlog();
  surveyBlog();
  cookieConsent();
  helloBars();
  setTables();
  exitModal();
  eventDataLayerActions();
  youtubeVideo();
  tooltip();
  ajaxForm();

  // async
  setTimeout(() => {
    scrollBehavior.enable();
  }, 1000);
});
